import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {categories, eventStatuses, provinces} from "../../../types/custom-types";
import {EventFilterModel} from "../../../model/request/event-filter.model";

@Component({
    selector: 'app-event-admin-filter',
    templateUrl: './event-admin-filter.component.html',
    standalone: false
})
export class EventAdminFilterComponent implements OnInit{

  form: FormGroup;

  @Input('hideTitle') hideTitle = false
  @Input('hideCategory') hideCategory = false
  @Input('hideEventStatus') hideEventStatus = false
  @Input('hideEventDate') hideEventDate = false
  @Input('hideProvince'  ) hideProvince = false

  @Output('submitFilter') eventSubmitEmitter = new EventEmitter<EventFilterModel>()

  provinces = provinces()
  categories = categories()
  eventStatuses = eventStatuses()
  eventMaxDate: Date = new Date();

  constructor() {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(){
    this.form = new FormGroup<any>({
      "title": new FormControl(null),
      "category": new FormControl(null),
      "eventStatus": new FormControl(null),
      "eventDate": new FormControl(null),
      "province": new FormControl(null),

    })
  }

  onClear() {
    this.form.reset()
    this.onSubmit();
  }

  onSubmit() {
    this.eventSubmitEmitter.emit(this.form.value)
  }
}
